define('models/zendesk/FormModel',['underscore','ObjectModel','LocalStorage','models/zendesk/FieldModel','app'],
    function (_,ObjectModel,LocalStorage,FieldModel,app) {
    //
    // Model Zendesk Form
    //
    return ObjectModel.extend({

        name:'ZendeskFormModel',
        idAttribute:'id',

        getFieldsId:function () {
            return this.get('ticket_field_ids');
        },

        getEmail:function(){
            return app.getCustomer().getEmail() || '';
        },

        getFields:function(){
            var model =this,
                fields = _(model.getFieldsId()).map(function(id){
                    return model.collection.supportCenter.getField(id);
                });
            //
            // ajout de champs statiques et obligatoires
            //
            var emailLabel = app.t("Email","Contact"),
                emailType = 'email',
                emailField = new FieldModel({
                    type:emailType,
                    id:emailType,
                    raw_title:emailLabel,
                    title:emailLabel
                }),
                uploadLabel = app.t('Ajouter un fichier','UI'),
                uploadType = 'upload',
                uploadField = new FieldModel({
                    type:uploadType,
                    id:uploadType,
                    raw_title:uploadLabel,
                    title:uploadLabel,
                    required_in_portal:false
                })
            ;

            fields.unshift(emailField);
            fields.push(uploadField);
            //
            return _(fields);
        }

    })
});
